import { useState } from "react";
import styles from "../Shared/CommonFields.module.css";
import { Collapsible } from "@shopify/polaris";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import useBundleMixpanelHook from "../../../../hooks/useBundleMixpanelHook";
import { FormCheckbox } from "../../../../components/FormFields";

export const DiscountCombinations = ({
    alone = false,
    bundleType = "volume",
}: {
    alone?: boolean;
    bundleType?: string;
}) => {
    const { trackFormSections } = useBundleMixpanelHook();
    const [expandAdvanceDiscountCombination, setexpandAdvanceDiscountCombination] = useState(false);

    return (
        <div style={{ ...(alone && { marginTop: "15px" }) }}>
            <div
                className={styles.flexHorizontalContainer}
                onClick={() =>
                    setexpandAdvanceDiscountCombination((prev) => {
                        trackFormSections({
                            cta: "Form Section",
                            ctaType: `Discount Combinations ${prev ? "Collapsed" : "Expanded"}`,
                            bundleType: bundleType,
                        });
                        return !prev;
                    })
                }
                style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "8px 0",
                }}
            >
                <p className={styles.combineTitle} style={{ margin: 0, fontWeight: "medium" }}>
                    Combine this discount with other
                </p>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        transform: expandAdvanceDiscountCombination ? "rotate(90deg)" : "rotate(270deg)",
                    }}
                >
                    <MdOutlineArrowBackIosNew size={12} />
                </div>
            </div>

            <Collapsible
                open={expandAdvanceDiscountCombination}
                transition={{
                    duration: "500ms",
                    timingFunction: "ease-in-out",
                }}
                expandOnPrint
                id="basic-collapsible"
            >
                <div
                    className={`${styles.formCol}`}
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        paddingTop: "8px",
                    }}
                >
                    <FormCheckbox label="Order discounts" name="order_discounts" />
                    <FormCheckbox label="Product discounts" name="product_discounts" />
                    <FormCheckbox label="Shipping discounts" name="shipping_discounts" />
                </div>
            </Collapsible>
        </div>
    );
};
